export const RouteGetReportPowerBIWorkspaceReports = "/report/powerbi/workspace/reports";

export interface ReportPowerBIWorkspaceReport {
  id: string;
  name: string;
  embedUrl: string;
}

export interface ResponseGetReportPowerBIWorkspaceReports {
  workspaceId: string;
  workspaceName: string;
  reports: ReportPowerBIWorkspaceReport[];
}
